import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Error404 } from './components/route-error/Error404';
import { Error403 } from './components/route-error/Error403';
import { Error500 } from './components/route-error/Error500';

export function AppErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <Error404 error={error.data} />;
    }

    if (error.status === 403) {
      return <Error403 error={error.data} />;
    }
  }

  return <Error500 />;
}
